import { Plus, Barbell, ChartLineUp } from "@phosphor-icons/react";
import { T } from "../../themes";
import { BODY_FIELDS } from "../../constants";
import MeasurementSparkline from "../../components/MeasurementSparkline";
import { Btn, RecoveryCard } from "../../workoutHelpers";
import AppHeader from "../../components/AppHeader";

export default function BodyMeasurementsScreen({bodyMeasurements,bodyMeasForm,setBodyMeasForm,showBodyMeas,setShowBodyMeas,bodyMeasLoading,saveBodyMeasurement,persona,sessions,library,darkMode,setDarkMode,profile}){
  return(
    <div style={{background:T.pageBg,minHeight:"100dvh"}}>
      <AppHeader
        title="Body"
        subtitle="Measurements & recovery"
        currentApp="lift"
        darkMode={darkMode}
        onToggleDarkMode={()=>setDarkMode(d=>!d)}
        username={profile?.username}
      />

      <div style={{padding:"0 16px 8px"}}>
        {sessions?.length > 0 && (
          <RecoveryCard sessions={sessions} library={library}/>
        )}
        <Btn onClick={()=>setShowBodyMeas(v=>!v)} style={{marginBottom:14,background:T.orange||"#f97316"}}>
          {showBodyMeas?"✕ Cancel":<><Plus size={15} weight="bold"/> Log today's measurements</>}
        </Btn>
        {showBodyMeas&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,padding:16,marginBottom:10}}>
            <p style={{margin:"0 0 12px",fontSize:13,fontWeight:600,color:T.inkDark,fontFamily:T.fontSans}}>Log measurements</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
              {BODY_FIELDS.map(f=>(
                <div key={f.key}>
                  <label style={{color:T.inkDark,fontSize:13,fontWeight:600,marginBottom:4,fontFamily:T.fontSans,display:"block"}}>{f.label} ({f.unit})</label>
                  <input type="number" step={f.step} value={bodyMeasForm[f.key]||""} onChange={e=>setBodyMeasForm(prev=>({...prev,[f.key]:e.target.value}))}
                    placeholder="0"
                    style={{background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:T.radiusSm,padding:"10px 14px",fontSize:15,color:T.inkDark,width:"100%",outline:"none",fontFamily:T.fontSans,boxSizing:"border-box"}}/>
                </div>
              ))}
            </div>
            <Btn onClick={()=>saveBodyMeasurement(bodyMeasForm)} disabled={bodyMeasLoading||Object.keys(bodyMeasForm).every(k=>!bodyMeasForm[k])}>
              {bodyMeasLoading?"Saving...":"Save"}
            </Btn>
          </div>
        )}
        {bodyMeasurements.length>0&&(
          <>
            {/* Latest snapshot */}
            <div style={{background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:18,marginBottom:10,overflow:"hidden"}}>
              <div style={{background:T.tileBg,borderRadius:"18px 18px 0 0",padding:"14px 18px",display:"flex",alignItems:"center",gap:10,borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
                <span style={{fontSize:20}}>📅</span>
                <div>
                  <div style={{color:T.tileAccent,fontWeight:700,fontSize:15,fontFamily:T.fontDisplay}}>Latest entry</div>
                  <div style={{color:T.inkFaint,fontSize:12}}>{new Date(bodyMeasurements[0].date+"T00:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}</div>
                </div>
              </div>
              <div style={{padding:16}}>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8}}>
                  {BODY_FIELDS.filter(f=>bodyMeasurements[0][f.key]!=null).map(f=>(
                    <div key={f.key} style={{background:T.surfaceMid,borderRadius:12,padding:"12px 16px",minWidth:100}}>
                      <p style={{margin:0,fontSize:11,fontFamily:T.fontSans,fontWeight:600,color:T.inkMuted,letterSpacing:0.5,marginBottom:4}}>{f.label}</p>
                      <p style={{margin:0,fontSize:22,fontFamily:T.fontDisplay,fontWeight:700,color:T.inkDark}}>{parseFloat(bodyMeasurements[0][f.key]).toFixed(1)}<span style={{fontSize:14,color:T.inkMuted}}> {f.unit}</span></p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Per-field trends */}
            {BODY_FIELDS.filter(f=>{
              const vals=bodyMeasurements.filter(m=>m[f.key]!=null);
              return vals.length>=2;
            }).map(f=>{
              const pts=[...bodyMeasurements].reverse().filter(m=>m[f.key]!=null).map(m=>({v:parseFloat(m[f.key]),date:m.date}));
              const first=pts[0].v, last=pts[pts.length-1].v, delta=+(last-first).toFixed(1);
              const good=(f.key==="weight_kg"||f.key==="body_fat_pct"||f.key==="waist_cm")?delta<=0:delta>=0;
              const fieldEmoji={weight_kg:"⚖️",body_fat_pct:"🔥",chest_cm:"📏",waist_cm:"📏",hips_cm:"📏"};
              const emoji=fieldEmoji[f.key]||"📐";
              return(
                <div key={f.key} style={{background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:18,marginBottom:8,overflow:"hidden"}}>
                  <div style={{background:T.tileBg,borderRadius:"18px 18px 0 0",padding:"14px 18px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <span style={{fontSize:20}}>{emoji}</span>
                      <div>
                        <div style={{color:T.tileAccent,fontWeight:700,fontSize:15,fontFamily:T.fontDisplay}}>{f.label} trend</div>
                        <div style={{color:T.inkFaint,fontSize:12}}>Last {pts.length} entries</div>
                      </div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{color:T.tileAccent,fontWeight:700,fontSize:18,fontFamily:T.fontDisplay}}>{last.toFixed(1)} {f.unit}</div>
                      <div style={{color:good?T.nutriGreen:T.red,fontSize:12}}>{delta>0?"+":""}{delta} {f.unit}</div>
                    </div>
                  </div>
                  <div style={{width:"100%",padding:"12px 16px 16px"}}>
                    <MeasurementSparkline data={pts} color={T.tileAccent||T.accent} width="100%" height={120}/>
                  </div>
                </div>
              );
            })}
          </>
        )}
        {/* Quick log chips — always visible */}
        <div style={{marginBottom:10}}>
          <p style={{fontSize:10,fontWeight:700,color:T.inkMuted,letterSpacing:"1px",fontFamily:T.fontSans,marginBottom:6}}>Quick log</p>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {["Weight","Waist","Chest","Arms"].map(label=>(
              <button key={label} onClick={()=>setShowBodyMeas(true)} style={{background:T.card,border:`1px solid ${T.cardBorder}`,borderRadius:20,padding:"7px 14px",fontSize:12,fontFamily:T.fontSans,fontWeight:600,color:T.inkDark,cursor:"pointer"}}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Measurement history */}
        {bodyMeasurements.length>=2&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,overflow:"hidden",marginBottom:10}}>
            <div style={{padding:"11px 16px",borderBottom:`1px solid ${T.cardBorder}`}}>
              <p style={{margin:0,fontSize:13,fontFamily:T.fontDisplay,fontWeight:800,color:T.inkDark}}>Measurement history</p>
            </div>
            {bodyMeasurements.slice(0,5).map((m,i)=>{
              const hasFields=BODY_FIELDS.filter(f=>m[f.key]!=null);
              return(
                <div key={m.date} style={{padding:"10px 16px",borderBottom:i<Math.min(bodyMeasurements.length,5)-1?`1px solid ${T.cardBorder}`:"none",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
                  <span style={{fontSize:12,fontFamily:T.fontSans,fontWeight:600,color:T.inkMuted,flexShrink:0}}>
                    {new Date(m.date+"T00:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"short"})}
                  </span>
                  <div style={{display:"flex",gap:10,flexWrap:"wrap",flex:1,justifyContent:"flex-end"}}>
                    {hasFields.map(f=>(
                      <span key={f.key} style={{fontSize:12,fontFamily:T.fontSans,fontWeight:600,color:T.inkDark}}>
                        {f.label.split(" ")[0]}: <span style={{color:T.primary}}>{parseFloat(m[f.key]).toFixed(1)}{f.unit}</span>
                      </span>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {bodyMeasurements.length===0&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,padding:16}}><div style={{textAlign:"center",padding:"16px 0",color:T.inkMuted}}>
            <Barbell size={28} weight="bold" style={{margin:"0 auto 8px"}}/>
            <p style={{fontSize:13,fontFamily:T.fontDisplay,fontWeight:800}}>No measurements yet</p>
            <p style={{fontSize:11,fontFamily:T.fontSans}}>Log your first entry to start tracking body composition.</p>
          </div></div>
        )}
        {bodyMeasurements.length===1&&(
          <div style={{background:T.card,borderRadius:18,border:`1px solid ${T.cardBorder}`,padding:"14px 16px",display:"flex",alignItems:"center",gap:12,marginBottom:8}}>
            <ChartLineUp size={22} color={T.primary}/>
            <p style={{margin:0,fontSize:12,fontFamily:T.fontSans,color:T.inkMuted,lineHeight:1.4}}>Log your measurements weekly to unlock trends and track progress over time.</p>
          </div>
        )}
      </div>
    </div>
  );
}
